import { useMemo } from 'react';

import { PortalErrorBoundary } from '~/components/PortalErrorBoundary';
import { UserSettings } from '~/scenes/PortalModules/User/UserSettings';
import {
  NavigationRoutingStructure,
  StructuredModuleRouter,
} from '~/scenes/PortalViews/components/StructuredModuleRouter';

export const UserViews = () => {
  const routingStructure = useMemo((): NavigationRoutingStructure[] => {
    return [
      {
        path: 'settings',
        label: 'Settings',
        component: <UserSettings />,
      },
    ];
  }, []);

  return (
    <PortalErrorBoundary>
      <StructuredModuleRouter routingStructure={routingStructure} />
    </PortalErrorBoundary>
  );
};
